import React from 'react';
import styles from '../MyShopNavigation/MobileNavigator/MobileNavigator.module.scss';
import { Bars3Icon as Burger, XMarkIcon as Close } from '@heroicons/react/20/solid';

const OnboardingMobileNavigator = ({ onToggle, mobileExpanded, shop }) => {
	const title = shop?.name || 'Onboarding';

	return (
		<div className={styles.mobileNavigator}>
			{mobileExpanded ? (
				<Close className={styles.toggle} onClick={onToggle} />
			) : (
				<>
					<Burger className={styles.toggle} onClick={onToggle} />
					{title}
				</>
			)}
		</div>
	);
};

export default OnboardingMobileNavigator;
